import { render, staticRenderFns } from "./AntispasmodicInput.vue?vue&type=template&id=2f812d2d&"
import script from "./AntispasmodicInput.vue?vue&type=script&lang=js&"
export * from "./AntispasmodicInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSwitch } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {
  VCheckbox,
  VLayout,
  VSwitch,
  VTextField,
})
